// /* eslint-disable */
import React, { useEffect, useState } from 'react';
import { authorizedPost, toggleLoading } from '../../store/actions';
import { Box, Button, CircularProgress, MenuItem, Modal, Stack, Typography } from '@mui/material';
import { tableStyle } from '../../components';
import { DataGrid } from '@mui/x-data-grid';
import AvailabilityUpdation from '../../components/AvailabilityUpdation';
import { ACTIVATE_ROOMTYPE_OTA, ADD_NEW_ROOMTYPE_OTA, LIST_ALL_ROOMTYPE_OTAS } from '../../graphql';
import { Add } from '@mui/icons-material';
import Header from '../../components/Header';
import { CssTextField } from '../../components/TextField';

const allOtas = ["bookingdotcom", "agoda", "goibibo", "yatra", "expedia", "booklogic"]

function RoomtypeOtas({ roomtypeId, dispatch, colors }) {
    const [otaList, setOtaList] = useState([]);
    const [selectedOta, setSelectedOta] = useState("");
    const [roomtypeCode, setRoomtypeCode] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, [])

    const fetchData = async() => {
        dispatch(toggleLoading(true));
        let response = await authorizedPost(LIST_ALL_ROOMTYPE_OTAS, {roomtypeId: roomtypeId })
        if(response?.data){
            setOtaList(response.data.list_all_roomtype_otas.data);
        }
        dispatch(toggleLoading(false));
    }

    const handleSubmit = async(e) => {
        e.preventDefault();
        setIsLoading(true);
        let data = {
            id: roomtypeId,
            ota: selectedOta,
            roomtypeCode: roomtypeCode,
        }
        console.log(data);
        await authorizedPost(ADD_NEW_ROOMTYPE_OTA, data);
        await fetchData();
        setSelectedOta("");
        setRoomtypeCode("");
        setOpen(false);
        setIsLoading(false);
    }

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { sm: 400, xs: "90%" },
        bgcolor: colors.primary[400],
        outline: "none",
        boxShadow: 24,
        p: 2,
    };

    const columns = [
        {
            field: "ota",
            headerName: "Ota Name",
            cellClassName: "name-column--cell",
            width: 200,
        },
        { field: "roomtype_code", headerName: "Room type code", width: 200 },
        {
            field: "is_active",
            headerName: "Availability",
            width: 150,
            renderCell: ({ row: { is_active, _id } }) => {
                return (
                    <AvailabilityUpdation
                        isActive={is_active}
                        action={async() => {
                            await authorizedPost(ACTIVATE_ROOMTYPE_OTA, { id: _id })
                            fetchData()
                        }}
                    />
                );
            },
        },
    ];

    return (
        <>
            <Box mb={15}>
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    alignItems={"end"}
                    m="20px 0"
                >
                    <Typography variant='h4' fontWeight="bold">
                        OTA LIST
                    </Typography>
                    <Box>
                        <Button
                            sx={{
                                backgroundColor: colors.blueAccent[700],
                                color: colors.grey[100],
                                fontSize: "14px",
                                fontWeight: "bold",
                                padding: { sm: "10px 20px", xs: "5px 10px" },
                            }}
                            onClick={() => setOpen(true)}
                        >
                            <Add sx={{ mr: "10px" }} />
                            Add new ota
                        </Button>
                    </Box>
                </Box>
                <Box
                    m="8px 0 0 0"
                    height="350px"
                    sx={tableStyle(colors)}
                >
                    <DataGrid
                        rows={otaList}
                        columns={columns}
                        // components={{ Footer: CustomFooter }}
                        getRowId={(row) => row?._id}
                    />
                </Box>

                <Modal
                    open={open}
                    onClose={() => setOpen(false)}
                >
                    <Box sx={modalStyle}>
                        <Header title="ADD NEW OTA" titleVariant="h4" />
                        <form onSubmit={handleSubmit}>
                            <Stack spacing={2}>
                                <CssTextField
                                    fullWidth
                                    required
                                    select
                                    size="small"
                                    label="OTA"
                                    value={selectedOta}
                                    // SelectProps={{ multiple: true }}
                                    onChange={(e) => setSelectedOta(e.target.value)}
                                >
                                    {allOtas?.map((ota, i) => (
                                        <MenuItem value={ota} key={i}>
                                            {ota}
                                        </MenuItem>
                                    ))}
                                </CssTextField>
                                <CssTextField
                                    fullWidth
                                    required
                                    size="small"
                                    type="text"
                                    label="Room type code"
                                    placeholder="Room type code"
                                    value={roomtypeCode ?? ""}
                                    onChange={(e) => setRoomtypeCode(e.target.value?.replace(" ", ""))}
                                />
                                <Button
                                    fullWidth
                                    size="large"
                                    type="submit"
                                    color="secondary"
                                    variant="contained"
                                    sx={{ fontSize: "15px" }}
                                >
                                    {isLoading ? <CircularProgress color="inherit" size={24} /> : <b>Submit</b>}
                                </Button>
                            </Stack>
                        </form>
                    </Box>
                </Modal>
            </Box>
        </>
    )
}

export default RoomtypeOtas;